import * as React from "react";

import { skipToken } from "@tanstack/react-query";
import loadingAnimation from "@v2/components/reploader.json";
import { useCurrentWorkspace } from "@v2/contexts/WorkspaceDashboardContext";
import { subscriptionRouter } from "@v2/trpc/routes/subscription";
import Lottie from "lottie-react";

import PaymentFailedBanner from "./PaymentFailedBanner";
import PlanComparison from "./plan-comparison/PlanComparison";
import PlanSummary from "./plan-summary/PlanSummary";

const Billing = () => {
  const workspace = useCurrentWorkspace();

  const { data: activeSubscription, isLoading: isLoadingActiveSubscription } =
    subscriptionRouter.getActiveSubscription.useQuery(
      workspace?.id ? { workspaceId: workspace.id } : skipToken,
    );

  if (isLoadingActiveSubscription || !workspace) {
    return (
      <Lottie
        animationData={loadingAnimation}
        loop={true}
        className="z-10 w-[200px]"
      />
    );
  }

  return (
    <div className="flex flex-col gap-12 w-full">
      <div className="flex flex-col gap-6">
        <PaymentFailedBanner />
        <PlanSummary
          activeSubscription={activeSubscription ?? undefined}
          workspace={workspace}
        />
        <PlanComparison activeSubscription={activeSubscription ?? undefined} />
      </div>
    </div>
  );
};

export default Billing;
